import * as React from 'react';
import { NumberField, Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';
import { TranslateField } from "../components/TranslateField";

export const OrganizationNotificationShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<NumberField source="id" label="#"/>
				<TextField source="title" label="TITLE"/>
				<TextField source="body" label="BODY"/>
				<NumberField source="dayInMonth" label="DAY_IN_MONTH"/>
				<TranslateField source="language" label="LANGUAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
